/**
 * 外呼系统类型定义
 */

// 座席状态
export enum SeatStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  DELETED = 'deleted',
}

// 通话状态
export enum CallStatus {
  INITIATED = 'initiated',
  CALLER_RINGING = 'caller_ringing',
  CALLER_ANSWERED = 'caller_answered',
  CALLEE_RINGING = 'callee_ringing',
  CALLEE_ANSWERED = 'callee_answered',
  CONNECTED = 'connected',
  COMPLETED = 'completed',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

// 座席
export interface OutboundSeat {
  id: number;
  seat_account: string;
  bind_number: string;
  app_id: string;
  status: SeatStatus;
  is_verified: boolean;
  user_id: number;
  total_calls: number;
  total_duration: number;
  remark?: string;
  created_at: string;
  updated_at: string;
}

// 创建座席
export interface CreateSeatRequest {
  bind_number: string;
  user_id: number;
  remark?: string;
}

// 外呼记录
export interface OutboundCallRecord {
  id: number;
  session_id: string;
  virtual_number?: string;
  caller: string;
  callee: string;
  lead_id: number;
  seat_id: number;
  user_id: number;
  status: CallStatus;
  call_start_time?: string;
  caller_alerting_time?: string;
  caller_answer_time?: string;
  callee_alerting_time?: string;
  callee_answer_time?: string;
  call_end_time?: string;
  bill_duration: number;
  has_recording: boolean;
  recording_start_time?: string;
  fail_reason?: string;
  fail_point?: string;
  call_cost: number;
  remark?: string;
  created_at: string;
  updated_at: string;
}

// 发起外呼
export interface MakeCallRequest {
  lead_id: number;
  callee: string;
  max_duration?: number;
  remark?: string;
}

// 外呼记录列表
export interface OutboundCallListResponse {
  total: number;
  items: OutboundCallRecord[];
}

// 录音
export interface OutboundRecording {
  id: number;
  call_record_id: number;
  original_url?: string;
  download_time?: string;
  cos_key?: string;
  cos_url?: string;
  file_size?: number;
  duration?: number;
  file_format: string;
  is_downloaded: boolean;
  download_failed: boolean;
  fail_reason?: string;
  created_at: string;
  updated_at: string;
}

// 统计数据
export interface OutboundStatistics {
  total_calls: number;
  completed_calls: number;
  failed_calls: number;
  total_duration: number;
  avg_duration: number;
  total_cost: number;
  success_rate: number;
}

// 查询参数
export interface OutboundCallQuery {
  lead_id?: number;
  user_id?: number;
  status?: CallStatus;
  start_date?: string;
  end_date?: string;
  page?: number;
  page_size?: number;
}
